<main class="container tender-details">
  @if (!isTenderLoading && tenderData) {
    <header class="tender-details__header">
      <div class="tender-details__header-main">
        <pwj-breadcrumbs [breadcrumbsData]="breadcrumbsData"></pwj-breadcrumbs>

        <div class="tender-details__status-row">
          <span
            class="tender-details__badge"
            [class.tender-details__badge--future]="
              tenderData?.state === tenderStates.In_The_Future
            "
            [class.tender-details__badge--expired]="
              tenderData?.state === tenderStates.Expired
            ">
            {{ stateLabelKey | translate }}
          </span>
        </div>
      </div>

      <div class="tender-details__actions">
        <pwj-options-menu
          [menuOptions]="menuOptions"
          [isRowMode]="true"></pwj-options-menu>
      </div>
    </header>

    <section class="tender-details__layout">
      <div class="tender-details__media-column">
        <div class="tender-details__media-row">
          <div class="tender-details__gallery-wrap">
            <span class="tender-details__verified-badge">
              <i class="iconsax" icon-name="shield-tick"></i>
              {{ 'tenders.verifiedProcurementStandard' | translate }}
            </span>

            <pwj-gallery
              [mediaData]="tenderData?.media || []"
              [mediaListCount]="4"
              [isColumnListMode]="true"
              previewWidth="800"
              previewHeight="600"
              previewWidthClass="!max-w-full"
              previewHeightClass="!max-h-full"
              listImgWidth="56"
              listImgHeight="56"
              listImgWidthClass="!w-56"
              listImgHeightClass="!h-56"
              [previewAlt]="
                (tenderData?.title | translateData) || 'tender'
              "></pwj-gallery>
          </div>

          <div class="tender-details__meta-grid">
            <pwj-tender-meta-card
              label="tenders.tenderCode"
              [value]="'#' + (tenderData?.code || '-')"></pwj-tender-meta-card>
            <pwj-tender-meta-card
              label="tenders.requestVolume"
              [value]="requestVolumeLabel"></pwj-tender-meta-card>
            <pwj-tender-meta-card
              label="tenders.targetLocation"
              [value]="targetLocationLabel"></pwj-tender-meta-card>
          </div>
        </div>
      </div>

      <aside class="tender-details__sidebar">
        <pwj-tender-info-card [tender]="tenderData"></pwj-tender-info-card>

        <pwj-tender-proposal-panel
          [tender]="tenderData"
          [isActive]="tenderData?.state === tenderStates.Active"
          (submitQuote)="submitBid()"></pwj-tender-proposal-panel>

        <pwj-tender-support-card></pwj-tender-support-card>
      </aside>
    </section>

    <pwj-tender-guidelines-section [tender]="tenderData"></pwj-tender-guidelines-section>

    <ng-template
      [pwjHasAccess]="[roles.CreateTenderAll, roles.CreateTenderSelf]">
      <a
        href="{{ panelUrl }}/tenders/create"
        target="_blank"
        rel="noopener noreferrer"
        class="tender-details__create-btn">
        <pwj-button
          variant="primary"
          size="large"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          type="button">
          {{ 'tenders.createNewTender' | translate }}
        </pwj-button>
      </a>
    </ng-template>
  } @else {
    <pwj-tenders-detail-skeleton></pwj-tenders-detail-skeleton>
  }
</main>
